import React, { useState, useEffect, useRef } from 'react';
import style from './css/japaadse.module.css';
import { Link } from 'react-router-dom';

import alumni1 from '../../../assets/charis.jpg';
import alumni2 from '../../../assets/Vincent.JPG';
import alumni3 from '../../../assets/nino.JPG';

const testimonials = [
    {
      text: `"Studying at Aptech Lekki changed my life. I transitioned easily to Middlesex University and graduated First Class! Highly recommended."`,
      author: "Al-Azim Afolabi A., Middlesex University",
    },
    {
      text: `"The practical projects prepared me for real-world challenges. I completed my Bachelor's Degree in record time and with excellent results."`,
      author: "Ridwan Bolaji, Middlesex University",
    },
    {
      text: `"Thanks to Aptech Lekki, I saved so much money while getting a world-class education abroad!"`,
      author: "Ifeanyi Ese Oruaro, Middlesex University",
    },
  ];
  
  const alumniList = [
    { image: alumni1, name: "Charis Olamide Erin", university: "Middlesex University" },
    { image: alumni2, name: "Vincent Essien", university: "Middlesex University" },
    { image: alumni3, name: "Nino Ayodele Osisanya", university: "Middlesex University" }
  ];
  
  const JapaADSE = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
  
    return (
      <section className={style.japaContainer}>
        
        {/* Hero Banner */}
        <div className={style.heroBanner}>
          <h1 className={`${style.heroTitle} ${style.fadeText}`}>Your UK Degree Starts Here</h1>
          <p className={`${style.heroSubtitle} ${style.fadeText}`}>
            From Aptech Lekki to Middlesex and Bolton Universities — Graduate faster, smarter, and save huge!
          </p>
          <Link to="/apply" className={style.heroBtn}>
            Get Started
          </Link>
        </div>
  
        {/* Fast Track to UK Degree Section */}
        <header className={style.japaHeader}>
          <h1 className={style.japaTitle}>Your Fast-Track to a UK Degree</h1>
          <p className={style.japaSubtitle}>
            Complete your Advanced Diploma in Software Engineering (ADSE) at Aptech Lekki in just 2 years — divided into 4 semesters — and earn your Bachelor's Degree at Middlesex or Bolton Universities (UK or Dubai campuses) in just 1 more year!
          </p>
        </header>
  
        <div className={style.japaContent}>
          {[
            { title: "No JAMB Required — SSCE is Enough!", desc: "Forget the stress of JAMB. All you need is your SSCE." },
            { title: "Practical, Hands-on Learning", desc: "Our curriculum is fully practical, project-based, and skill-driven." },
            { title: "Save Huge Costs Compared to Studying Abroad Directly", desc: "Study 2 years here, 1 year abroad — saving you millions." },
            { title: "Success Stories That Inspire", desc: "We have many First-Class graduates who completed their ADSE and excelled abroad." },
            { title: "Beat the System — Graduate Faster", desc: "Earn your Bachelor's Degree in just 3 years instead of 5 years!" }
          ].map((item, idx) => (
            <div key={idx} className={style.japaHighlight}>
              <h2>{item.title}</h2>
              <p>{item.desc}</p>
            </div>
          ))}
  
          <div className={style.japaAction}>
            <Link to="/apply" className={style.enrollBtn}>
              Enroll Now
            </Link>
          </div>
        </div>
  
        {/* Alumni Section */}
        <section className={style.alumniSection}>
          <h2 className={style.alumniTitle}>Meet Our First-Class Graduates</h2>
          <div className={style.alumniGrid}>
            {alumniList.map((alumni, idx) => (
              <div key={idx} className={style.alumniCard}>
                <div className={style.badge}>🎓 Graduate</div>
                <img src={alumni.image} alt={alumni.name} className={style.alumniImage} />
                <h3>{alumni.name}</h3>
                <p>{alumni.university} — First Class</p>
              </div>
            ))}
          </div>
        </section>
  
        {/* Testimonials Section */}
        <section className={style.testimonialSection}>
          <h2 className={style.testimonialTitle}>What Our Alumni Say</h2>
  
          <div
            className={style.testimonialSlider}
            onScroll={(e) => {
              const slideWidth = e.target.clientWidth;
              const scrollPos = e.target.scrollLeft;
              const activeIndex = Math.round(scrollPos / slideWidth);
              setCurrentSlide(activeIndex);
            }}
          >
            {testimonials.map((testimonial, idx) => (
              <div key={idx} className={style.testimonialSlide}>
                <p className={style.testimonialText}>{testimonial.text}</p>
                <h4 className={style.testimonialAuthor}>— {testimonial.author}</h4>
              </div>
            ))}
          </div>
  
          <div className={style.dots}>
            {testimonials.map((_, idx) => (
              <div key={idx} className={`${style.dot} ${idx === currentSlide ? style.activeDot : ''}`}></div>
            ))}
          </div>
        </section>

      </section>
    );
  };
  
  export default JapaADSE;